<template>
    <div class="col-xs-2 col-sm-2 col-md-1 col-lg-1 fullHeight leftNavBarBG position-Fixed overflow-y-scroll paddingLeft5px paddingRight5px">

        <router-link to="/">
          <img :src= "imgSrc" class="img-responsive img-width-100Perc  margin-Top-14Perc" alt="IPL-Logo" @click="toggleDashBoardMenu($event)">
        </router-link>
        <hr>
        <nav>
          <ul class="nav nav-pills nav-stacked">
            <!-- <li class="language-nonactive" role="presentation" @click="toggleDashBoardMenu($event)"><router-link to="/dashboard">Dashboard</router-link></li> -->
            <li class="language-nonactive" role="presentation" @click="toggleDashBoardMenu($event)"><router-link to="/">Dashboard</router-link></li>
            <li class="language-nonactive" role="presentation" @click="toggleNewReportMenu($event)"><router-link to="/newreport">New Report</router-link></li>
            <li class="language-nonactive" role="presentation" v-if="!isUserGroupAdmin">
              <a data-target="collapse-participant-menu" data-toggle="collapse" @click="toggleContentMenu($event)" class="cursor-pointer">
                Content <span :class="[ collapseContentMenu ? 'right-caret' : 'caret']"></span>
              </a>
              <ul id="collapse-participant-menu" class="nav nav-pills nav-stacked" :class="{collapse: collapseContentMenu}" >
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,1)"><router-link to="/courses" :class="{'text-color-yellow' :isActiveCourses}">Courses</router-link></li>
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,2)"><router-link to="/managecontent" :class="{'text-color-yellow' :isActiveManageContent}">Manage Content</router-link></li>
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,33)"><router-link to="/mastertopic" :class="{'text-color-yellow' :isActiveMasterTopic}"><span v-html="topicOptionName"></span></router-link></li>
                  <!-- <li class="language-nonactive" role="presentation" @click="selectedMenu($event,36)"><router-link to="/learninglevel" :class="{'text-color-yellow' :isActiveLearningLevel}">Learning Level</router-link></li> -->
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,38)"><router-link to="/assessment" :class="{'text-color-yellow' :isActiveAssessment}">Assessments</router-link></li>
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,39)"><router-link to="/assessmentjourney" :class="{'text-color-yellow' :isActiveJourneyAssessment}">Assessment Journey</router-link></li>
                  <!-- <li class="language-nonactive" role="presentation"><router-link to="/challenges">Challenges</router-link></li> -->
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,3)"><router-link to="/challenges" :class="{'text-color-yellow' :isActiveChallenges}">Challenges</router-link></li>
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,4)"><router-link to="/filerepository" :class="{'text-color-yellow' :isActiveFileUploader}">File Repository</router-link></li>
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,37)"><router-link to="/screenloading" :class="{'text-color-yellow' :isActiveScreenLoading}">Loading Screen</router-link></li>
              </ul>
            </li>
            <li class="language-nonactive" role="presentation" v-if="!isUserGroupAdmin">
              <a data-target="collapse-participant-menu" data-toggle="collapse" @click="toggleParticipantMenu($event)" class="cursor-pointer">
                Users <span :class="[ collapseParticipantMenu ? 'right-caret' : 'caret']"></span>
              </a>
              <ul id="collapse-participant-menu" class="nav nav-pills nav-stacked" :class="{collapse: collapseParticipantMenu}" >
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,5)"><router-link to="/users" :class="{'text-color-yellow' :isActiveParticipants}">Participants</router-link></li>
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,6)"><router-link to="/groups" :class="{'text-color-yellow' :isActiveGroups}" >Groups</router-link></li>
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,7)"><router-link to="/cohorts" :class="{'text-color-yellow' :isActiveCohorts}">Cohorts</router-link></li>
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,32)"><router-link to="/utilities" :class="{'text-color-yellow' :isActiveUtilities}">Utilities</router-link></li>
              </ul>
            </li>
            <li class="language-nonactive" role="presentation" v-if="!isUserGroupAdmin">
              <a data-target="collapse-participant-menu" data-toggle="collapse" @click="toggleLEAPStMenu($event)" class="cursor-pointer">
                LEAPS <span :class="[ collapseLeapsMenu ? 'right-caret' : 'caret']"></span>
              </a>
              <ul id="collapse-participant-menu" class="nav nav-pills nav-stacked" :class="{collapse: collapseLeapsMenu}" >
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,46)"><router-link to="/energylibrary" :class="{'text-color-yellow' :isActiveLeapsEnergy}">Energy Library</router-link></li>
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,47)"><router-link to="/affirmationlibrary" :class="{'text-color-yellow' :isActiveLeapsAffirmation}">Affirmation Library</router-link></li>
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,50)"><router-link to="/intentionlibrary" :class="{'text-color-yellow' :isActiveLeapsIntention}">Intention Library</router-link></li>
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,44)"><router-link to="/actionlibrary" :class="{'text-color-yellow' :isActiveLeapsAction}">Action Library</router-link></li>
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,45)"><router-link to="/categorylibrary" :class="{'text-color-yellow' :isActiveLeapsCategory}">Category Library</router-link></li>
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,42)"><router-link to="/challengelibrary" :class="{'text-color-yellow' :isActiveLeapsChallenges}">Goals Library</router-link></li>
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,43)"><router-link to="/meditationlibrary" :class="{'text-color-yellow' :isActiveLeapsMeditation}">Meditation Library</router-link></li>
              </ul>
            </li>
            <li class="language-nonactive" role="presentation" v-if="!isUserGroupAdmin">
              <a data-target="collapse-participant-menu" data-toggle="collapse" @click="toggleRMenu($event)" class="cursor-pointer">
                Reports <span :class="[ collapseReportMenu ? 'right-caret' : 'caret']"></span>
              </a>
              <ul id="collapse-participant-menu" class="nav nav-pills nav-stacked" :class="{collapse: collapseReportMenu}" >
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,10)"><router-link to="/userprogress" :class="{'text-color-yellow' :isActiveUserProgress}">User Progress</router-link></li>
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,23)"><router-link to="/lessonwiseprogress" :class="{'text-color-yellow' :isActiveLessonwiseProgress}">Lessonwise Progress</router-link></li>
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,41)"><router-link to="/elementwiseprogress" :class="{'text-color-yellow' :isActiveElementwiseProgress}">Elementwise Progress</router-link></li>
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,13)"><router-link to="/reflection" :class="{'text-color-yellow' :isActiveDiscussions}">Reflection</router-link></li>
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,9)"><router-link to="/challengereport" :class="{'text-color-yellow' :isActiveChallengesReport}">Challenges / Teachback</router-link></li>
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,11)"><router-link to="/mcqreport" :class="{'text-color-yellow' :isActiveMCQReport}">MCQ</router-link></li>
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,48)"><router-link to="/meetingmentorreport" :class="{'text-color-yellow' :isActiveMeetingMentorReport}">Meeting Mentor</router-link></li>
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,49)"><router-link to="/assessmentreport" :class="{'text-color-yellow' :isActiveAssessmentReport}">Assessment</router-link></li>
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,12)"><router-link to="/deepdive" :class="{'text-color-yellow' :isActiveDeepDive}">Deep Dive</router-link></li>
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,24)"><router-link to="/sendgrid" :class="{'text-color-yellow' :isActiveSendGrid}">Send Grid</router-link></li>
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,27)"><router-link to="/m365Report" :class="{'text-color-yellow' :isActiveM365Report}">Moments</router-link></li>
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,34)"><router-link to="/momentsreport" :class="{'text-color-yellow' :isActiveMomentsReport}">Moments V2</router-link></li>
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,28)"><router-link to="/missionReport" :class="{'text-color-yellow' :isActiveMissionReport}">Mission</router-link></li>
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,29)"><router-link to="/adaptiveGameReport" :class="{'text-color-yellow' :isActiveAdaptiveGameReport}">Learning Game</router-link></li>
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,30)"><router-link to="/descriptivevideoreport" :class="{'text-color-yellow' :isActiveVATConsumptionReport}">Descriptive Video</router-link></li>
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,31)"><router-link to="/milestonereport" :class="{'text-color-yellow' :isActiveMilestoneReport}">Milestones</router-link></li>
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,35)"><router-link to="/certificatereport" :class="{'text-color-yellow' :isActiveCertificateReport}">Certificate</router-link></li>
                <li class="language-nonactive" role="presentation" @click="selectedMenu($event,53)"><router-link to="/lpreport" :class="{'text-color-yellow' :isActiveLPReport}">Learn Perform</router-link></li>
              </ul>
             <!-- <router-link to="#">Reports</router-link> -->
            </li>
            <!-- <li class="language-nonactive" role="presentation"><router-link to="#">Mails</router-link></li> -->

              <!-- start file repository -->
                    <!-- <li class="language-nonactive" role="presentation">
                      <a data-target="collapse-participant-menu" data-toggle="collapse" @click="toggleFileRepositoryMenu($event)" >
                        File Repository <span :class="[ collapseFileRepositoryMenu ? 'right-caret' : 'caret']"></span>
                      </a>
                      <ul id="collapse-participant-menu" class="nav nav-pills nav-stacked" :class="{collapse: collapseFileRepositoryMenu}" >
                          <li class="language-nonactive" role="presentation"><a>File Uploader</a></li>
                      </ul>
                    </li> -->
              <!-- end of file repository -->
            <!--start of e-mail menu-->
            <li class="language-nonactive" role="presentation" v-if="!isUserGroupAdmin">
              <a data-target="collapse-participant-menu" data-toggle="collapse" @click="toggleEmailMenu($event)" class="cursor-pointer">
                Emails <span :class="[ collapseEmailMenu ? 'right-caret' : 'caret']"></span>
              </a>
              <ul id="collapse-participant-menu" class="nav nav-pills nav-stacked" :class="{collapse: collapseEmailMenu}" >
                  <!-- <li class="language-nonactive" role="presentation"><a>File Uploader</a></li>  remove from mails-->
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,14)"><router-link to="/email" class="language-nonactive" :class="{'text-color-yellow' :isActiveEmailUsers}">Email Users</router-link></li>
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,15)"><router-link to="/progressionemail" :class="{'text-color-yellow' :isActiveProgressionEmail}">Progression Email</router-link></li>
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,52)"><router-link to="/dashboardemail" :class="{'text-color-yellow' :isActiveDashboardEmail}">Dashboard Email</router-link></li>
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,16)"><router-link to="/viewsentemails" :class="{'text-color-yellow' :isActiveViewSentEmails}">View Sent Emails</router-link></li>
              </ul>
             </li>
             <!--end of e-mail menu-->
             <!-- ss Notification -->
            <li class="language-nonactive" role="presentation">
              <a data-target="collapse-notifications-menu" data-toggle="collapse" @click="toggleNotificationsMenu($event)" class="cursor-pointer">
                Notif <span :class="[ collapseNotificationMenu ? 'right-caret' : 'caret']"></span>
              </a>
                <ul id="collapse-notifications-menu" class="nav nav-pills nav-stacked" :class="{collapse: collapseNotificationMenu}" >
                  <li class="language-nonactive" role="presentation" v-if="!isUserGroupAdmin" @click="selectedMenu($event,26)"><router-link to="/mentora365" :class="{'text-color-yellow' :isActiveMentora365}">Notifications</router-link></li>
                  <li class="language-nonactive" role="presentation" v-if="!isUserGroupAdmin" @click="selectedMenu($event,51)"><router-link to="/msnotif" :class="{'text-color-yellow' :isActiveMSNotification}">MS Notifications</router-link></li>
                  <!-- <li class="language-nonactive" role="presentation" @click="selectedMenu($event,17)"><router-link to="" :class="{'text-color-yellow' :isActiveManageAdmins}" v-if="!isUserGroupAdmin">Manage Admins</router-link> -->
                </ul>
            </li>
            <!-- End Of Notification -->
            <li class="language-nonactive" role="presentation">
              <a data-target="collapse-settings-menu" data-toggle="collapse" @click="toggleSettingsMenu()" class="cursor-pointer">
                Settings <span :class="[ collapseSettingsMenu ? 'right-caret' : 'caret']"></span>
              </a>
                <ul id="collapse-settings-menu" class="nav nav-pills nav-stacked" :class="{collapse: collapseSettingsMenu}" >
                  <li class="language-nonactive" role="presentation" v-if="!isUserGroupAdmin" @click="selectedMenu($event,25)"><router-link to="/ssoconfiguration" :class="{'text-color-yellow' :isActiveSSOConfiguration}">SSO Configuration</router-link></li>
                  <!-- <li class="language-nonactive" role="presentation" @click="selectedMenu($event,17)"><router-link to="" :class="{'text-color-yellow' :isActiveManageAdmins}" v-if="!isUserGroupAdmin">Manage Admins</router-link> -->
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,22)"><router-link to="/adminactivity" :class="{'text-color-yellow' :isActiveAdminActivity}" v-if="!isUserGroupAdmin">Admin Activity</router-link></li>
                  <!-- <li class="language-nonactive" role="presentation" @click="selectedMenu($event,18)"><router-link to="" :class="{'text-color-yellow' :isActiveNotifications}" v-if="!isUserGroupAdmin">Notifications</router-link></li> -->
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,19)"><router-link to="/profile" :class="{'text-color-yellow' :isActiveEditProfile}">Edit Profile</router-link></li>
                  <!-- <li class="language-nonactive" role="presentation" @click="selectedMenu($event,20)"><router-link to="" :class="{'text-color-yellow' :isActiveResetPassword}">Reset Password</router-link></li> -->
                  <li class="language-nonactive" role="presentation" @click="selectedMenu($event,21)"><router-link to="/" :class="{'text-color-yellow' :isActiveLogout}">Logout</router-link></li>
                </ul>
            </li>
            <!--<li role="presentation" class="dropdown language-nonactive" :class="{open: ddVisible}" @click="toggleDropdown($event)">
              <a class="dropdown-toggle" data-toggle="dropdown" href="#"  role="button" aria-haspopup="true" aria-expanded="false">
                Dropdown <span class="right-caret"></span>
              </a>
              <ul class="nav" >
                <li class="language-nonactive" role="presentation"><a href="#">Item 1</a></li>
                <li class="language-nonactive" role="presentation"><a href="#">Item 2</a></li>
                <li class="language-nonactive" role="presentation"><a href="#">Item 3</a></li>
                <li class="language-nonactive" role="presentation"><a href="#">Item 4</a></li>
              </ul>
            </li> -->
          </ul>
          <!--<div class="nav nav-pills nav-stacked">
            <div><router-link to="/" class="left-nav-menu-item">Dashboard</router-link></div>
            <div><router-link to="/courses" class="left-nav-menu-item">Content</router-link></div>
            <div><router-link to="/" class="left-nav-menu-item">Participants</router-link></div>
            <div><router-link to="/" class="left-nav-menu-item">Reports</router-link></div>
            <div><router-link to="/" class="left-nav-menu-item">Communications</router-link></div>
            <div><router-link to="/" class="left-nav-menu-item">Settings</router-link></div>
            <div>
             <dropdown :visible="ddVisible">
              <a href="#" @click="ddVisible = !ddVisible" class="left-nav-menu-item">Menu</a>
              <div slot="dropdown" class="my-dropdown-dd">
                <aside class="menu">
                  <div class="menu-list menu-item" style="list-style: none;">
                    <div><a href="#" class="left-nav-menu-item">Item 1</a></div>
                    <div><a href="#" class="left-nav-menu-item">Item 2</a></div>
                  </div>
                </aside>
              </div>
            </dropdown>
            </div>
          </div> -->
        </nav>

    </div>
</template>

<script>
// import router from 'vue-router'
import dropdown from 'vue-my-dropdown'
import ipllettermark from '../assets/images/ipllettermark.svg'
import { constants } from '@/utils/constants'
export default{
  name: 'LeftNavBar',
  created: function () {
    this.openSelectedMenu()
  },
  mounted: function () {
    this.openSelectedMenu()
  },
  data: function () {
    return {
      imgSrc: ipllettermark,
      topicOptionName: 'Master <br/>Topic',
      collapseSettingsMenu: true,
      collapseNotificationMenu: true,
      collapseParticipantMenu: true,
      collapseContentMenu: true,
      collapseReportMenu: true,
      collapseFileRepositoryMenu: true,
      collapseEmailMenu: true,
      collapseLeapsMenu: true,
      isActiveCourses: false,
      isActiveManageContent: false,
      isActiveMasterTopic: false,
      isActiveLearningLevel: false,
      isActiveAssessment: false,
      isActiveJourneyAssessment: false,
      isActiveChallenges: false,
      isActiveLeapsChallenges: false,
      isActiveLeapsMeditation: false,
      isActiveLeapsAction: false,
      isActiveLeapsEnergy: false,
      isActiveLeapsAffirmation: false,
      isActiveLeapsIntention: false,
      isActiveLeapsCategory: false,
      isActiveFileUploader: false,
      isActiveScreenLoading: false,
      isActiveParticipants: false,
      isActiveGroups: false,
      isActiveCohorts: false,
      isActiveUtilities: false,
      isActiveUserResponses: false,
      isActiveChallengesReport: false,
      isActiveUserProgress: false,
      isActiveLessonwiseProgress: false,
      isActiveElementwiseProgress: false,
      isActiveMCQReport: false,
      isActiveMeetingMentorReport: false,
      isActiveAssessmentReport: false,
      isActiveDeepDive: false,
      isActiveSendGrid: false,
      isActiveM365Report: false,
      isActiveMomentsReport: false,
      isActiveMissionReport: false,
      isActiveAdaptiveGameReport: false,
      isActiveVATConsumptionReport: false,
      isActiveMilestoneReport: false,
      isActiveCertificateReport: false,
      isActiveLPReport: false,
      isActiveDiscussions: false,
      isActiveEmailUsers: false,
      isActiveProgressionEmail: false,
      isActiveDashboardEmail: false,
      isActiveViewSentEmails: false,
      isActiveManageAdmins: false,
      isActiveSSOConfiguration: false,
      isActiveAdminActivity: false,
      isActiveNotifications: false,
      isActiveEditProfile: false,
      isActiveResetPassword: false,
      isActiveLogout: false,
      isActiveMentora365: false,
      isActiveMSNotification: false
    }
  },
  components: {
    dropdown
  },
  computed: {
    isUserGroupAdmin: {
      get: function () {
        if (this.$store.state.curr_user.AccountType === constants.UserAccountType.Group_Admin) {
          return true
        } else {
          return false
        }
      }
    },
    hightLightMenu: {
      get: function () {
        // AK: In order to show explictly redirected selected option
        this.resetAllSubMenuOptionFlag()
        this.openSelectedMenu()
        return this.$store.state.hightLightOptionExplictly
      }
    }
  },
  methods: {
    openSelectedMenu: function () {
      console.log('called')
      if (!this.$store.state.isComingFromLogin) {
        var selectedMenu = localStorage.getItem('selectedMenu')
        var selectedSubMenu = localStorage.getItem('selectedSubMenu')
        if (selectedMenu !== undefined) {
          switch (parseInt(selectedMenu)) {
            case constants.MenuOptionsEnum.Dashboard:
              break
            case constants.MenuOptionsEnum.NewReport:
              break
            case constants.MenuOptionsEnum.Content:
              this.collapseContentMenu = false
              break
            case constants.MenuOptionsEnum.Users:
              this.collapseParticipantMenu = false
              break
            case constants.MenuOptionsEnum.Reports:
              this.collapseReportMenu = false
              break
            case constants.MenuOptionsEnum.Emails:
              this.collapseEmailMenu = false
              break
            case constants.MenuOptionsEnum.Settings:
              this.collapseSettingsMenu = false
              break
            case constants.MenuOptionsEnum.Notifications:
              this.collapseNotificationMenu = false
              break
            case constants.MenuOptionsEnum.LEAPS:
              this.collapseLeapsMenu = false
          }
        }
        if (selectedSubMenu !== undefined) {
          switch (parseInt(selectedSubMenu)) {
            case constants.SubMenuOptionsEnum.Courses:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveCourses = true
              break
            case constants.SubMenuOptionsEnum.ManageContent:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveManageContent = true
              break
            case constants.SubMenuOptionsEnum.MasterTopic:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveMasterTopic = true
              break
            case constants.SubMenuOptionsEnum.LearningLevel:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveLearningLevel = true
              break
            case constants.SubMenuOptionsEnum.Assessment:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveAssessment = true
              break
            case constants.SubMenuOptionsEnum.AssessmentJourney:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveJourneyAssessment = true
              break
            case constants.SubMenuOptionsEnum.Challenges:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveChallenges = true
              break
            case constants.SubMenuOptionsEnum.LEAPSChallenges:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveLeapsChallenges = true
              break
            case constants.SubMenuOptionsEnum.LEAPSMeditation:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveLeapsMeditation = true
              break
            case constants.SubMenuOptionsEnum.LEAPSAction:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveLeapsAction = true
              break
            case constants.SubMenuOptionsEnum.LEAPSEnergy:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveLeapsEnergy = true
              break
            case constants.SubMenuOptionsEnum.LEAPSAffirmation:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveLeapsAffirmation = true
              break
            case constants.SubMenuOptionsEnum.LEAPSIntention:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveLeapsIntention = true
              break
            case constants.SubMenuOptionsEnum.LEAPSCategory:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveLeapsCategory = true
              break
            case constants.SubMenuOptionsEnum.FileUploader:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveFileUploader = true
              break
            case constants.SubMenuOptionsEnum.ScreenLoading:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveScreenLoading = true
              break
            case constants.SubMenuOptionsEnum.Participants:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveParticipants = true
              break
            case constants.SubMenuOptionsEnum.Groups:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveGroups = true
              break
            case constants.SubMenuOptionsEnum.Cohorts:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveCohorts = true
              break
            case constants.SubMenuOptionsEnum.Utilities:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveUtilities = true
              break
            case constants.SubMenuOptionsEnum.UserResponses:
              this.isActiveUserResponses = true
              break
            case constants.SubMenuOptionsEnum.ChallengeReport:
              this.isActiveChallengesReport = true
              break
            case constants.SubMenuOptionsEnum.UserProgress:
              this.isActiveUserProgress = true
              break
            case constants.SubMenuOptionsEnum.McqReport:
              this.isActiveMCQReport = true
              break
            case constants.SubMenuOptionsEnum.MeetingMentor:
              this.isActiveMeetingMentorReport = true
              break
            case constants.SubMenuOptionsEnum.AssessmentSubType:
              this.isActiveAssessmentReport = true
              break
            case constants.SubMenuOptionsEnum.DeepDive:
              this.isActiveDeepDive = true
              break
            case constants.SubMenuOptionsEnum.SendGrid:
              this.isActiveSendGrid = true
              break
            case constants.SubMenuOptionsEnum.M365Report:
              this.isActiveM365Report = true
              break
            case constants.SubMenuOptionsEnum.Moments:
              this.isActiveMomentsReport = true
              break
            case constants.SubMenuOptionsEnum.MissionReport:
              this.isActiveMissionReport = true
              break
            case constants.SubMenuOptionsEnum.AdaptiveGameReport:
              this.isActiveAdaptiveGameReport = true
              break
            case constants.SubMenuOptionsEnum.VATConsumptionReport:
              this.isActiveVATConsumptionReport = true
              break
            case constants.SubMenuOptionsEnum.MilestoneReport:
              this.isActiveMilestoneReport = true
              break
            case constants.SubMenuOptionsEnum.Certificate:
              this.isActiveCertificateReport = true
              break
            case constants.SubMenuOptionsEnum.LPReport:
              this.isActiveLPReport = true
              break
            case constants.SubMenuOptionsEnum.Discussions:
              this.isActiveDiscussions = true
              break
            case constants.SubMenuOptionsEnum.EmailUsers:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveEmailUsers = true
              break
            case constants.SubMenuOptionsEnum.ProgressionEmail:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveProgressionEmail = true
              break
            case constants.SubMenuOptionsEnum.DashboardEmail:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveDashboardEmail = true
              break
            case constants.SubMenuOptionsEnum.ViewSentEmails:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveViewSentEmails = true
              break
            case constants.SubMenuOptionsEnum.ManageAdmins:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveManageAdmins = true
              break
            case constants.SubMenuOptionsEnum.SSOConfiguration:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveSSOConfiguration = true
              break
            case constants.SubMenuOptionsEnum.AdminActivity:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveAdminActivity = true
              break
            case constants.SubMenuOptionsEnum.Notifications:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveNotifications = true
              break
            case constants.SubMenuOptionsEnum.EditProfile:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveEditProfile = true
              break
            case constants.SubMenuOptionsEnum.ResetPassword:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveResetPassword = true
              break
            case constants.SubMenuOptionsEnum.LessonwiseProgress:
              this.isActiveLessonwiseProgress = true
              break
            case constants.SubMenuOptionsEnum.ElementwiseProgress:
              this.isActiveElementwiseProgress = true
              break
            case constants.SubMenuOptionsEnum.Mentora365:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveMentora365 = true
              break
            case constants.SubMenuOptionsEnum.MSNotif:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveMSNotification = true
              break
            case constants.SubMenuOptionsEnum.Logout:
              this.resetSelectedGroupCourseAndCohortObj()
              this.isActiveLogout = true
              this.resetAllSubMenuOptionFlag()
              this.resetStateValues()
              break
            default:
              this.resetSelectedGroupCourseAndCohortObj()
              this.resetAllSubMenuOptionFlag()
              break
          }
        }
      } else {
        // AK: User coming from login screen / first time
        this.$router.push('/')
        this.$store.state.isComingFromLogin = false
      }
    },
    resetSelectedGroupCourseAndCohortObj: function () {
      this.$store.state.selectedGroupCourseObj = {}
      this.$store.state.selectedCohortObj = {}
    },
    toggleSettingsMenu () {
      console.log('TOGGLE SETTINGS : ')
      this.collapseSettingsMenu = !this.collapseSettingsMenu
      // Set all other flags to false
      this.collapseNotificationMenu = true
      this.collapseParticipantMenu = true
      this.collapseContentMenu = true
      this.collapseReportMenu = true
      this.collapseEmailMenu = true
      this.collapseLeapsMenu = true
      // AK: Store in localstorage in order to show previously selected open tab on page refresh
      localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
    },
    toggleNotificationsMenu (evtObj) {
      console.log('TOGGLE NOTIFICATION : ')
      this.collapseNotificationMenu = !this.collapseNotificationMenu
      // Set all other flags to false
      this.collapseSettingsMenu = true
      this.collapseParticipantMenu = true
      this.collapseContentMenu = true
      this.collapseReportMenu = true
      this.collapseEmailMenu = true
      this.collapseLeapsMenu = true
      // AK: Store in localstorage in order to show previously selected open tab on page refresh
      localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Notifications)
    },
    toggleParticipantMenu (evtObj) {
      console.log('NOTHING')
      this.collapseParticipantMenu = !this.collapseParticipantMenu
      this.collapseSettingsMenu = true
      this.collapseNotificationMenu = true
      this.collapseContentMenu = true
      this.collapseReportMenu = true
      this.collapseFileRepositoryMenu = true
      this.collapseEmailMenu = true
      this.collapseLeapsMenu = true
      // AK: Store in localstorage in order to show previously selected open tab on page refresh
      localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Users)
    },
    toggleContentMenu (evtObj) {
      this.collapseContentMenu = !this.collapseContentMenu
      this.collapseSettingsMenu = true
      this.collapseNotificationMenu = true
      this.collapseParticipantMenu = true
      this.collapseReportMenu = true
      this.collapseFileRepositoryMenu = true
      this.collapseEmailMenu = true
      this.collapseLeapsMenu = true
      // AK: Store in localstorage in order to show previously selected open tab on page refresh
      localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Content)
    },

    resetStateValues: function () {
      this.$store.commit('resetState')
    },
    /*
    logout () {
      var store = this.$store
      store.state.access_token = ''

      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
    },
    */
    toggleRMenu (evtObj) {
      console.log('NOTHING')
      this.collapseReportMenu = !this.collapseReportMenu
      this.collapseFileRepositoryMenu = true
      this.collapseSettingsMenu = true
      this.collapseNotificationMenu = true
      this.collapseParticipantMenu = true
      this.collapseContentMenu = true
      this.collapseEmailMenu = true
      this.collapseLeapsMenu = true
      // AK: Store in localstorage in order to show previously selected open tab on page refresh
      localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Reports)
    },

    toggleFileRepositoryMenu (evtObj) {
      console.log('NOTHING')
      this.collapseFileRepositoryMenu = !this.collapseFileRepositoryMenu
      this.collapseReportMenu = true
      this.collapseSettingsMenu = true
      this.collapseNotificationMenu = true
      this.collapseParticipantMenu = true
      this.collapseContentMenu = true
      this.collapseEmailMenu = true
      this.collapseLeapsMenu = true
      // AK: Store in localstorage in order to show previously selected open tab on page refresh
      // localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Users)
    },
    toggleEmailMenu (evtObj) {
      console.log('NOTHING')
      this.collapseEmailMenu = !this.collapseEmailMenu
      this.collapseReportMenu = true
      this.collapseFileRepositoryMenu = true
      this.collapseSettingsMenu = true
      this.collapseNotificationMenu = true
      this.collapseParticipantMenu = true
      this.collapseContentMenu = true
      this.collapseLeapsMenu = true
      // AK: Store in localstorage in order to show previously selected open tab on page refresh
      localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Emails)
    },
    toggleDashBoardMenu (evtObj) {
      console.log('NOTHING')
      this.resetSelectedGroupCourseAndCohortObj()
      this.collapseEmailMenu = true
      this.collapseReportMenu = true
      this.collapseFileRepositoryMenu = true
      this.collapseSettingsMenu = true
      this.collapseNotificationMenu = true
      this.collapseParticipantMenu = true
      this.collapseContentMenu = true
      this.collapseLeapsMenu = true
      // AK: Store in localstorage in order to show previously selected open tab on page refresh
      localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Dashboard)
      localStorage.setItem('selectedSubMenu', 0)
      this.resetAllSubMenuOptionFlag()
    },
    toggleNewReportMenu (evtObj) {
      console.log('NOTHING')
      this.resetSelectedGroupCourseAndCohortObj()
      this.collapseEmailMenu = true
      this.collapseReportMenu = true
      this.collapseFileRepositoryMenu = true
      this.collapseSettingsMenu = true
      this.collapseNotificationMenu = true
      this.collapseParticipantMenu = true
      this.collapseContentMenu = true
      this.collapseLeapsMenu = true
      // AK: Store in localstorage in order to show previously selected open tab on page refresh
      localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.NewReport)
      localStorage.setItem('selectedSubMenu', 0)
      this.resetAllSubMenuOptionFlag()
    },
    toggleLEAPStMenu (evtObj) {
      console.log('NOTHING')
      this.resetSelectedGroupCourseAndCohortObj()
      this.collapseLeapsMenu = !this.collapseLeapsMenu
      this.collapseEmailMenu = true
      this.collapseReportMenu = true
      this.collapseFileRepositoryMenu = true
      this.collapseSettingsMenu = true
      this.collapseNotificationMenu = true
      this.collapseParticipantMenu = true
      this.collapseContentMenu = true
      // AK: Store in localstorage in order to show previously selected open tab on page refresh
      localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.LEAPS)
    },
    resetAllSubMenuOptionFlag: function () {
      // AK: When user pressed on dashboard then reset all submenu flag to false again
      this.isActiveCourses = false
      this.isActiveManageContent = false
      this.isActiveMasterTopic = false
      this.isActiveLearningLevel = false
      this.isActiveAssessment = false
      this.isActiveJourneyAssessment = false
      this.isActiveChallenges = false
      this.isActiveLeapsChallenges = false
      this.isActiveLeapsMeditation = false
      this.isActiveLeapsAction = false
      this.isActiveLeapsEnergy = false
      this.isActiveLeapsAffirmation = false
      this.isActiveLeapsIntention = false
      this.isActiveLeapsCategory = false
      this.isActiveFileUploader = false
      this.isActiveScreenLoading = false
      this.isActiveParticipants = false
      this.isActiveGroups = false
      this.isActiveCohorts = false
      this.isActiveUtilities = false
      this.isActiveUserResponses = false
      this.isActiveChallengesReport = false
      this.isActiveUserProgress = false
      this.isActiveLessonwiseProgress = false
      this.isActiveElementwiseProgress = false
      this.isActiveMCQReport = false
      this.isActiveMeetingMentorReport = false
      this.isActiveAssessmentReport = false
      this.isActiveDeepDive = false
      this.isActiveSendGrid = false
      this.isActiveM365Report = false
      this.isActiveMomentsReport = false
      this.isActiveMissionReport = false
      this.isActiveAdaptiveGameReport = false
      this.isActiveVATConsumptionReport = false
      this.isActiveMilestoneReport = false
      this.isActiveCertificateReport = false
      this.isActiveLPReport = false
      this.isActiveDiscussions = false
      this.isActiveEmailUsers = false
      this.isActiveProgressionEmail = false
      this.isActiveDashboardEmail = false
      this.isActiveViewSentEmails = false
      this.isActiveManageAdmins = false
      this.isActiveSSOConfiguration = false
      this.isActiveAdminActivity = false
      this.isActiveNotifications = false
      this.isActiveEditProfile = false
      this.isActiveResetPassword = false
      this.isActiveLogout = false
      this.isActiveMentora365 = false
      this.isActiveMSNotification = false
    },
    selectedMenu (event, currentPageIndex) {
      // AK: If currentIndex is Logout then clear cache and Logout user
      if (currentPageIndex === constants.SubMenuOptionsEnum.Logout) {
        var store = this.$store
        var cookies = this.$cookies
        cookies.remove(constants.LOGIN_COOKIE_KEY)
        cookies.remove(constants.LOGIN_USER_COOKIE)
        store.state.isUserProfileLoaded = false
        localStorage.removeItem(constants.LOGIN_USER_COOKIE)
        localStorage.setItem('selectedMenu', 0)
        localStorage.setItem('selectedSubMenu', 0)
        this.resetStateValues()
      } else {
        // AK: Store in localstorage in order to show previously selected open tab on page refresh
        localStorage.setItem('selectedSubMenu', currentPageIndex)
        switch (currentPageIndex) {
          case constants.SubMenuOptionsEnum.LEAPSIntention:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = true
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.LEAPSAffirmation:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = true
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.LEAPSEnergy:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = true
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.LEAPSCategory:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = true
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.LEAPSAction:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = true
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.LEAPSMeditation:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = true
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.LEAPSChallenges:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = true
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.Courses:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = true
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.ManageContent:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = true
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.MasterTopic:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = true
            this.isActiveLearningLevel = false
            this.isActiveScreenLoading = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.LearningLevel:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = true
            this.isActiveScreenLoading = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.Assessment:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = true
            this.isActiveJourneyAssessment = false
            this.isActiveScreenLoading = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.AssessmentJourney:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveAssessment = false
            this.isActiveLearningLevel = false
            this.isActiveJourneyAssessment = true
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.Challenges:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = true
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.FileUploader:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = true
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.ScreenLoading:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveAssessment = false
            this.isActiveLearningLevel = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = true
            this.isActiveJourneyAssessment = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.Participants:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = true
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.Groups:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = true
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.Cohorts:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = true
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.Utilities:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = true
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.UserResponses:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = true
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.ChallengeReport:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = true
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.UserProgress:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = true
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.McqReport:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = true
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.AssessmentSubType:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = true
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.MeetingMentor:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = true
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.DeepDive:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = true
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.SendGrid:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = true
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.M365Report:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = true
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.Moments:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = true
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.MissionReport:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = true
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.AdaptiveGameReport:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = true
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.VATConsumptionReport:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = true
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.MilestoneReport:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = true
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.Certificate:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = true
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.LPReport:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = true
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.Discussions:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = true
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.EmailUsers:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = true
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.ProgressionEmail:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = true
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.DashboardEmail:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = true
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.ViewSentEmails:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = true
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.ManageAdmins:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = true
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.SSOConfiguration:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = true
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.AdminActivity:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = true
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.Notifications:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = true
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.EditProfile:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = true
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.ResetPassword:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = true
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.Logout:
            this.resetSelectedGroupCourseAndCohortObj()
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = true
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.ElementwiseProgress:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = true
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.LessonwiseProgress:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = true
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.Mentora365:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = true
            this.isActiveMSNotification = false
            break
          case constants.SubMenuOptionsEnum.MSNotif:
            this.isActiveCourses = false
            this.isActiveManageContent = false
            this.isActiveMasterTopic = false
            this.isActiveLearningLevel = false
            this.isActiveAssessment = false
            this.isActiveJourneyAssessment = false
            this.isActiveChallenges = false
            this.isActiveLeapsChallenges = false
            this.isActiveLeapsMeditation = false
            this.isActiveLeapsAction = false
            this.isActiveLeapsEnergy = false
            this.isActiveLeapsAffirmation = false
            this.isActiveLeapsIntention = false
            this.isActiveLeapsCategory = false
            this.isActiveFileUploader = false
            this.isActiveScreenLoading = false
            this.isActiveParticipants = false
            this.isActiveGroups = false
            this.isActiveCohorts = false
            this.isActiveUtilities = false
            this.isActiveUserResponses = false
            this.isActiveChallengesReport = false
            this.isActiveUserProgress = false
            this.isActiveLessonwiseProgress = false
            this.isActiveElementwiseProgress = false
            this.isActiveMCQReport = false
            this.isActiveMeetingMentorReport = false
            this.isActiveAssessmentReport = false
            this.isActiveDeepDive = false
            this.isActiveSendGrid = false
            this.isActiveM365Report = false
            this.isActiveMomentsReport = false
            this.isActiveMissionReport = false
            this.isActiveAdaptiveGameReport = false
            this.isActiveVATConsumptionReport = false
            this.isActiveMilestoneReport = false
            this.isActiveCertificateReport = false
            this.isActiveLPReport = false
            this.isActiveDiscussions = false
            this.isActiveEmailUsers = false
            this.isActiveProgressionEmail = false
            this.isActiveDashboardEmail = false
            this.isActiveViewSentEmails = false
            this.isActiveManageAdmins = false
            this.isActiveSSOConfiguration = false
            this.isActiveAdminActivity = false
            this.isActiveNotifications = false
            this.isActiveEditProfile = false
            this.isActiveResetPassword = false
            this.isActiveLogout = false
            this.isActiveMentora365 = false
            this.isActiveMSNotification = true
            break
          default:
            this.resetSelectedGroupCourseAndCohortObj()
            this.resetAllSubMenuOptionFlag()
            break
        }
      }
    }
  },
  watch: {
    hightLightMenu (newValue, oldValue) {
      // AK: In order to show explictly redirected selected option
      if (newValue) {
        this.resetAllSubMenuOptionFlag()
        this.openSelectedMenu()
        switch (parseInt(localStorage.getItem('selectedMenu'))) {
          case constants.MenuOptionsEnum.Settings:
            this.toggleSettingsMenu()
            break
        }
      } else {
        // console.log('Reset flag hightLightOptionExplictly to false')
      }
    }
  }
    // toggleReportMenu (evtObj) {
    //   console.log('NOTHING')
    //   this.collapseReportMenu = !this.collapseReportMenu
    //   this.collapseSettingsMenu = true
    //   this.collapseContentMenu = true
    // }
}
</script>

<style scoped>
.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.left-color-border
{
	border: 1px solid red;
}
.right-color-border
{
	border: 1px solid green;
}
.leftNavBarBG
{
	background-color: #34495e;
  display: block;
  /*border:1px solid #34495e; */
}
.font-size-14px{
	font-size: 30px;
}
.position-Fixed
{
	position:fixed;
}
.float-Right
{
	float: right;
}
.fullHeight
{
	height:100% !important;
}
.fi-border
{
	border: 1px solid white;
}
 .footer-img
 {
    margin: 0 auto !important;
    display: block;
    position: absolute;
    bottom: 0;
	  width: 30%;
 }
 .center-block {
   margin-left:auto;
   margin-right:auto;
   display:block;
}
.text-center {
   text-align:center
}
.margin-Top-14Perc
{
	margin-top: 14%;
}
.margin-Top-5Perc
{
	margin-top: 5%;
}
.admin-Panel-BG
{
  background-color: #f39c12;
}
.text-align-left
{
  text-align: left;
}
.margin-Left-4Perc
{
  margin-left: 4%;
}
.admin-Panel-Padding
{
  padding:0.1% 0% 0.1% 2%;
}
.font-size-2vw
{
  font-size: 2vw;
}
.right-caret {
    border-bottom: 4px solid transparent;
    border-top: 4px solid transparent;
    border-left: 4px solid #fff;
    display: inline-block;
    height: 0;
    opacity: 1;
    margin-left: 2px;
    vertical-align: center;
    width: 0;
}
.caret{
  margin-left: 2px;
}
.right-align {
  top: 0;
  left: 100%;
}
.nav > li.language-nonactive{
  margin: 0px;
  padding: 0px;
}
.nav > li.language-nonactive > a{
  color: lightgray;
  padding-left: 3px;
  padding-right: 5px;
  padding-top: 5px;
  font-size: 1.6rem;
}
.nav>li.language-nonactive>a:hover,
.nav>li.language-nonactive>a:focus,
.nav>li.language-nonactive>a:active{
  background-color:#34495e;
  color: white;
}

.nav>li.language-nonactive>ul>li.language-nonactive>a{
  color: rgba(243, 156, 18, 0.6);
  padding-left: 10px;
  padding-right: 5px;
  padding-top:5px;
  font-size: 1.3rem;
}

/*
.nav>li.language-nonactive>ul>li.language-nonactive>a:link,
.nav>li.language-nonactive>ul>li.language-nonactive>a:hover,
.nav>li.language-nonactive>ul>li.language-nonactive>a:focus,
.nav>li.language-nonactive>ul>li.language-nonactive>a:active
{
  background-color:#34495e;
  color: yellow;
} */
.text-color-yellow {
  color:#f39c12 !important;
  font-size: 1.5rem !important;
}

.overflow-y-scroll{
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-track-color: transparent;
}

.paddingLeft5px{
  padding-left: 5px;
}

.paddingRight5px{
  padding-right: 5px;
}
/*
nav > div > div{
  height: 35px;
  width: 100%;
  margin-top: 10px;
  cursor: pointer;
}

nav > div > div:hover{
  height: 35px;
  width: 100%;
  background-color: rgba(255, 0, 0, 0.466);
  margin-top: 10px;
}

nav > div > div > a.left-nav-menu-item{
  height: 35px;
  width: 100%;
  text-align: left;
  color: white;
  text-decoration: none;
  margin-top: 10px;
}

nav > div > div > a.left-nav-menu-item:hover{
  height: 35px;
  color: white;
  text-shadow: 0.5px 0.5px rgba(255, 255, 255, 0.5);
  text-decoration: none;
  background-color: rgba(52, 73, 94, 0.5);
}

nav > div > div > a.left-nav-menu-item:active{
  height: 35px;
  color: white;
  text-shadow: 0.5px 0.5px rgba(255, 255, 255, 0.5);
  text-decoration: none;
  background-color: rgba(52, 73, 94, 0.5);
}

.my-dropdown-dd{
  background-color: white;
  width: 150px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 8px 8px;
  box-shadow: 2px 2px rgba(128, 128, 128, 0.25);
}
.my-dropdown-dd > aside > div > div{
  height: 35px;
  width: 100%;
  text-align: left;

}
.my-dropdown-dd > aside > div > div:hover{
  height: 35px;
  width: 100%;
  background-color: rgba(128, 128, 128, 0.5);

}
.my-dropdown-dd > aside > div > div > a.left-nav-menu-item{

  width: 100%;
  text-align: left;
  color: #34495e;
  text-decoration: none;
  padding-left: 10px;
  vertical-align: middle;
}

.my-dropdown-dd > aside > div > div > a.left-nav-menu-item:hover{

  color: #34495e;
  width: 100%;
  padding-left: 10px;
  text-shadow: 0.5px 0.5px rgba(255, 255, 255, 0.5);
  text-decoration: none;
  vertical-align: middle;
}

.my-dropdown-dd > aside > div > div > a.left-nav-menu-item:active{
  width: 100%;
  color: #34495e;
  padding-left: 10px;
  text-shadow: 0.5px 0.5px rgba(255, 255, 255, 0.5);
  text-decoration: none;
  vertical-align: middle;
}

nav > div > div > dropdown > div{
  height: 35px;
  margin-top: 10px;
} */

.nav > li > a{
  padding-left: 0px;
  padding-right: 0px;
}
.cursor-pointer{
  cursor:pointer !important;
}
.img-width-100Perc{
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/LeftNavBar.vue